module.exports = __webpack_public_path__ + "static/media/experiment-shape-color.c27a9f5e.mov";